import { BGN, CZK, EUR, HUF, PLN, RON, UAH, USD } from '@layers/i18n/shared/currencies'
import { bg, cs, de, en, es, fr, hu, it, nl, pl, ro, sk, uk } from '@layers/i18n/shared/locales'

export default defineI18nConfig(() => ({
  legacy: false,
  locale: en.code,
  fallbackLocale: en.code,
  numberFormats: {
    [bg.code]: { currency: BGN },
    // [ch.code]: { currency: CHF },
    [cs.code]: { currency: CZK },
    // [da.code]: { currency: DKK },
    [de.code]: { currency: EUR },
    [en.code]: { currency: USD },
    [es.code]: { currency: EUR },
    [fr.code]: { currency: EUR },
    [hu.code]: { currency: HUF },
    [it.code]: { currency: EUR },
    [nl.code]: { currency: EUR },
    [pl.code]: { currency: PLN },
    [ro.code]: { currency: RON },
    [sk.code]: { currency: EUR },
    [uk.code]: { currency: UAH },
  },
}))
